import React from 'react';
import {Button} from 'react-bootstrap';
import {useRecordEvent} from 'aws-rum-react';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {IImageManualModel} from '../../types/manualFinder';
import { OverlayTooltip } from '../../components';

interface ManualDrawerFooterProps {
    imageManuals: IImageManualModel[];
    setIsFeedBackProvided: (value: boolean) => void;
    isFeedBackProvided: boolean;
}

const ManualDrawerFooter: React.FC<ManualDrawerFooterProps> = ({
                                                                   imageManuals,
                                                                   setIsFeedBackProvided,
                                                                   isFeedBackProvided,
                                                               }) => {
    const {t} = useTranslation();
    const recordEvent = useRecordEvent();

    const handleFeedback = (isFound: boolean) => {
        recordEvent("ManualFeedbackButtonsClicked", {
            status: isFound ? "Manual Found" : "Manual not found",
        });
        setIsFeedBackProvided(true);
        toast(t("ExtractedImages.FeedbackSubmitted"), {type: "success"});
    };

    return (
        <div className="d-flex justify-content-between p-3">
            <div className="customer-feedback-buttons mb-2">
                <OverlayTooltip tooltipContent={t("ExtractedImages.ManualButtonsTooltip")}/>
                <Button variant="success" disabled={isFeedBackProvided} onClick={() => handleFeedback(true)}
                        className="me-2">
                    {t("ExtractedImages.ManualFoundButton")}
                </Button>
                <Button variant="outline-danger" disabled={isFeedBackProvided} onClick={() => handleFeedback(false)}>
                    {t("ExtractedImages.ManualNotFoundButton")}
                </Button>
            </div>
        </div>
    );
};

export default ManualDrawerFooter;
